import { MainLayoutContainer } from "components/Layout";
import CustomTable from "components/Table/CustomTable";
import { Box, Stack, Typography } from "@mui/material";
import { useMentorList } from "./hooks/useMentorList";
import { CoachPetAvatar } from "components/VetStore/CoachPetAvatar";
import { TABLE_ACTIONS } from "helpers/constants";
import { SelectMentor } from "./component";

export const MentorList = () => {
  const { mentors, coaches, loading, error, selectMentor, deleteMentor } =
    useMentorList();

  const handleActionClick = (action: TABLE_ACTIONS, id: string) => {
    if (action === TABLE_ACTIONS.DELETE) {
      deleteMentor(id);
    }
  };

  return (
    <MainLayoutContainer
      title="My Mentors"
      loading={loading}
      error={error}
      buttonActions={
        <SelectMentor
          coaches={coaches}
          selectedMentors={mentors}
          onSelect={(mentor: any) => selectMentor(mentor.user_id)}
        />
      }
    >
      <Box>
        <Box mb={2}></Box>
        <CustomTable
          entities={mentors}
          handleActionClick={handleActionClick}
          fieldToFilter={(row: any, text: string) => {
            const filter = (text || "").toLowerCase();
            return row.name?.toLowerCase().includes(filter);
          }}
          columns={[
            {
              id: "name",
              label: "Mentor",
              value: (row: any) => (
                <Stack direction="row" spacing={3} alignItems="center">
                  <CoachPetAvatar
                    pictureUrl={row.picture_url}
                    name={row.name}
                    equippedStoreItems={row.equipped_store_items}
                  />
                  <Box>
                    <Typography variant="body2">{row.name}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {row.email}
                    </Typography>
                  </Box>
                </Stack>
              ),
            },
            { id: "actions", value: "" },
          ]}
          isSelectable={false}
          idColumn={"mentoring_id"}
          extraActionItems={[]}
          allowedMenuItems={[TABLE_ACTIONS.DELETE]}
        />
      </Box>
    </MainLayoutContainer>
  );
};
